import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import germanTranslation from './translation/de.json';
import translation from './translation/en.json';
import ukranianTranslation from './translation/ua.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translation,
    },
    de: {
      translation: germanTranslation,
    },
    uk: {
      translation: ukranianTranslation,
    },
  },
  lng: localStorage.getItem('language') || 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});
